import commonMixin from '@/mixins/templates/common';
import NoticeBanner from '@/components/comunication/notice-banner';
import { MAX_HIGHLIGHT_COUNT } from '@/helpers/notice.js';
import { mapMutations } from 'vuex';
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import 'swiper/swiper.scss';

export default {
  name       : 'NoticeCarousel',
  components : { NoticeBanner, Swiper, SwiperSlide },
  props      : {
    hasHighlightNotices: {
      type    : Boolean,
      default : false
    }
  },
  mixins: [commonMixin],
  data() {
    return {
      noticeBannerList : [],
      swiperOptions    : {
        a11y: {
          prevSlideMessage        : this.$t('notice.carouselPrevNoticeButton'),
          nextSlideMessage        : this.$t('notice.carouselNextNoticeButton'),
          paginationBulletMessage : this.$t('notice.carouselNavigationNoticeBullet')
        },
        spaceBetween   : 8,
        slidesPerView  : 'auto',
        centeredSlides : true,
        pagination     : {
          el        : '.carousel-swiper__pagination',
          clickable : true
        },
        navigation: {
          nextEl : '.carousel__next-button',
          prevEl : '.carousel__previous-button'
        }
      }
    };
  },
  mounted() {
    this.getNotices();
    this.$nuxt.$on('updatedHighlightNotices', this.updateHighlightNotices);
  },
  methods: {
    ...mapMutations({
      SET_UNREAD_NOTICES_COUNT: 'plataforma/noticesBoard/SET_UNREAD_NOTICES_COUNT'
    }),
    receiveNotices(notices, unreadNoticesCount = 0) {
      this.noticeBannerList = notices;
      if (this.noticeBannerList.length) {
        this.$emit('update:hasHighlightNotices', true);
      }

      this.SET_UNREAD_NOTICES_COUNT(unreadNoticesCount);
    },
    getNotices() {
      this.$services.notices().getNoticesList({
        courseId    : this.$route.params.courseId,
        isHighlight : true,
        perPage     : MAX_HIGHLIGHT_COUNT,
        page        : 1,
        sortBy      : 'sequence',
        order       : 'asc'
      })
        .then(res => {
          this.receiveNotices(res.notices, res.unreadNoticesCount);
        })
        .catch(errorMessage => this.$toast.error(errorMessage.message));
    },
    updateHighlightNotices(newNoticeList) {
      if (newNoticeList) {
        this.noticeBannerList = newNoticeList;
        return;
      }
      this.getNotices();
    },
    handleSeeNotice(noticeIndex) {
      this.$nuxt.$emit('changeIsOpenNoticeBoardDetailModal', {
        noticeId : this.noticeBannerList[noticeIndex].id,
        notices  : this.noticeBannerList
      });
    }
  },
  beforeDestroy() {
    this.$nuxt.$off('updatedHighlightNotices', this.updateHighlightNotices);
  }
};
